import script from "./storageSampleDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./storageSampleDetail.vue?vue&type=script&setup=true&lang=js"

import "./storageSampleDetail.vue?vue&type=style&index=0&id=53cc8bb6&lang=less"

const __exports__ = script;

export default __exports__